import React from "react";

const Certifs_QHSE_en = () => {
  const QHSE1 = "/assets/images/QHSE/Politique QSSE 2021.png";
  const QHSE2 = "/assets/images/QHSE/Politique QSSE Arabe2021png_Page1.png";

  return (
    <div>
      <section className="shop grid ">
        <div className="container">
          <div className="row">
            <div className="container">
              <div className="row">
                {/** */}
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="product mb-40">
                    <div className="product-image">
                      <a
                        className="button button-border mt-20"
                        data-toggle="modal"
                        data-target=".bd-qhse-01-modal-lg"
                        href="#/"
                      >
                        <img
                          style={{ height: "350px", width: "250px" }}
                          className="img-fluid mx-auto"
                          src={QHSE1}
                          alt="Quality, health, safety & environment policy"
                        />
                        <br />
                        <br />
                        <h3>Quality, health, safety & environment policy</h3>
                      </a>
                    </div>
                  </div>
                </div>
                {/** */}
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="product mb-40">
                    <div className="product-image">
                      <a
                        className="button button-border mt-20"
                        data-toggle="modal"
                        data-target=".bd-qhse-02-modal-lg"
                        href="#/"
                      >
                        <img
                          style={{ height: "350px", width: "250px" }}
                          className="img-fluid mx-auto"
                          src={QHSE2}
                          alt="Quality, health, safety & environment policy"
                        />
                        <br />
                        <br />
                        <h3>Quality, health, safety & environment policy</h3>
                      </a>
                    </div>
                  </div>
                </div>
                {/** 
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="product mb-40">
                    <div className="product-image">
                      <a
                        className="button button-border mt-20"
                        data-toggle="modal"
                        data-target=".bd-qhse-03-modal-lg"
                        href="#/"
                      >
                        <img
                          style={{ height: "350px", width: "250px" }}
                          className="img-fluid mx-auto"
                          src={certiso45001}
                          alt="CERTIFICAT ISO 45001"
                        />
                        <br />
                        <br />
                        <h3>CERTIFICAT ISO 45001</h3>
                      </a>
                    </div>
                  </div>
                </div>
               */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/** */}
      <div
        className="modal fade bd-qhse-01-modal-lg"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body text-justify">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                X
              </button>
              <br />
              <img
                className="img-fluid mx-auto"
                src={QHSE1}
                alt="Quality, health, safety & environment policy"
              />
            </div>
          </div>
        </div>
      </div>
      {/** */}
      <div
        className="modal fade bd-qhse-02-modal-lg"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body text-justify">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                X
              </button>
              <br />
              <img
                className="img-fluid mx-auto"
                src={QHSE2}
                alt="Quality, health, safety & environment policy"
              />
            </div>
          </div>
        </div>
      </div>
      {/** 
      <div
        className="modal fade bd-qhse-03-modal-lg"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body text-justify">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                X
              </button>
              <br />
              <img
                className="img-fluid mx-auto"
                src={certiso45001}
                alt="ISO 45001"
              />
            </div>
          </div>
        </div>
      </div>
     */}
    </div>
  );
};

export default Certifs_QHSE_en;
